var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const SalesGenius_Amiparisss = {
    nbDiscounts: 5,
    jsApiEnabled: true,
    debugFlag: false,
    rules: {
        discounts_cart_items: {},
        discounts_catalog: "",
        raw_discounts_catalog: "",
        discounts_variants: {},
        discounts_target: "",
        discounts_free_gift: ""
    },
    currentProductId: null,
    currentDebugTraceId: "",
    cartUpdateDebugContent: "",
    api: {
        PRICE_MODIFIER_ABSOLUTE: "a",
        PRICE_MODIFIER_PERCENTAGE_COMPAREATPRICE: "p",
        PRICE_MODIFIER_PERCENTAGE_PRICE: "q",
        PRICE_MODIFIER_AMOUNT_COMPAREATPRICE: "d",
        PRICE_MODIFIER_AMOUNT_PRICE: "b",
        typeToString(type) {
            if (type === this.PRICE_MODIFIER_ABSOLUTE) {
                return "Absolute price";
            }
            else if (type === this.PRICE_MODIFIER_PERCENTAGE_COMPAREATPRICE) {
                return "% from compare at price";
            }
            else if (type === this.PRICE_MODIFIER_PERCENTAGE_PRICE) {
                return "% from price";
            }
            else if (type === this.PRICE_MODIFIER_AMOUNT_COMPAREATPRICE) {
                return "Amount from compare at price";
            }
            else if (type === this.PRICE_MODIFIER_AMOUNT_PRICE) {
                return "Amount from price";
            }
            return type;
        },
        evalExpectedParameter() {
            console.warn("[Sales Genius] Expected parameters are ", {
                "debug?": "boolean",
                variant: {
                    id: "number",
                    price: "number",
                    "compareAtPrice?": "number",
                    "collectionsIds?": "Array<number>"
                },
                metafields: {
                    shop: {
                        sales_genius_rules: "string"
                    },
                    variant: {
                        sales_genius_rules: "string"
                    }
                },
                "context?": {
                    "marketHandle?": "string",
                    "segmentIds?": "Array<number>",
                    "isLoggedIn?": "boolean",
                    "date?": "Date"
                }
            });
        },
        showTableWithColumns(cols) {
            const topSep = "  ";
            const numRows = Math.max(...cols.map(x => x.length));
            cols.forEach(col => {
                while (col.length < numRows)
                    col.push("");
            });
            const widths = cols.map(col => Math.max(...col.map(x => {
                if (typeof x === "object" && x.hasOwnProperty("msg")) {
                    return x.msg.length;
                }
                else if (typeof x === "string") {
                    return x.length;
                }
                else {
                    return 0;
                }
            })));
            const nonTopSep = "".padEnd(topSep.length);
            for (let i = 0; i < numRows; i++) {
                const sep = (i === 0) ? topSep : nonTopSep;
                const msg = cols.map((col, j) => {
                    const coli = col[i];
                    if (typeof coli === "object" && coli.hasOwnProperty("msg")) {
                        if (coli.back === "green")
                            return "\x1b[38;2;255;255;255m\x1b[48;2;0;100;0m" + coli.msg.padEnd(widths[j]) + sep + "\x1b[0m";
                        if (coli.color === "green")
                            return "\x1b[32m" + coli.msg.padEnd(widths[j]) + sep + "\x1b[0m";
                        if (coli.color === "grey")
                            return "\x1b[90m" + coli.msg.padEnd(widths[j]) + sep + "\x1b[0m";
                        if (coli.color === "red")
                            return "\x1b[31m" + coli.msg.padEnd(widths[j]) + sep + "\x1b[0m";
                        return coli.msg.padEnd(widths[j]) + sep;
                    }
                    else if (typeof coli === "string") {
                        return coli.padEnd(widths[j]) + sep;
                    }
                    else {
                        return "" + sep;
                    }
                }).join("");
                console.debug(msg);
            }
        },
        statusDetailsToString(data) {
            var _a, _b, _c, _d, _e, _f;
            if (data.details === "") {
                return { msg: "-", color: "grey" };
            }
            else if (data.status === "fail") {
                return { msg: (_b = (_a = data.details) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "X", color: "red" };
            }
            else if (data.status === "pass") {
                return { msg: (_d = (_c = data.details) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "V", color: "green" };
            }
            else if (data.status === "skipped") {
                return { msg: (_f = (_e = data.details) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : "-", color: "grey" };
            }
            else {
                return { msg: "X", color: "red" };
            }
        },
        eval(params) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
            if (!params) {
                console.warn("[Sales Genius] Missing required parameters");
                this.evalExpectedParameter();
                return 0;
            }
            if (!((_a = params.variant) === null || _a === void 0 ? void 0 : _a.id)) {
                console.warn("[Sales Genius] Missing required parameters property 'variant.id'");
                this.evalExpectedParameter();
                return (_c = (_b = params.variant) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : 0;
            }
            else if (isNaN(params.variant.id) || params.variant.id <= 0) {
                console.warn("[Sales Genius] Invalid parameters property 'variant.id'");
                this.evalExpectedParameter();
                return (_e = (_d = params.variant) === null || _d === void 0 ? void 0 : _d.price) !== null && _e !== void 0 ? _e : 0;
            }
            if (!((_f = params.variant) === null || _f === void 0 ? void 0 : _f.price)) {
                console.warn("[Sales Genius] Missing required parameters property 'variant.price'");
                this.evalExpectedParameter();
                return 0;
            }
            else if (isNaN(params.variant.price) || params.variant.price < 0) {
                console.warn("[Sales Genius] Invalid parameters property 'variant.price'");
                this.evalExpectedParameter();
                return 0;
            }
            if (!((_h = (_g = params.metafields) === null || _g === void 0 ? void 0 : _g.shop) === null || _h === void 0 ? void 0 : _h.sales_genius_rules)) {
                console.warn("[Sales Genius API] Missing required parameters property 'metafields.shop.sales_genius_rules'");
                this.evalExpectedParameter();
                return (_k = (_j = params.variant) === null || _j === void 0 ? void 0 : _j.price) !== null && _k !== void 0 ? _k : 0;
            }
            else if (typeof params.metafields.shop.sales_genius_rules !== "string") {
                console.warn("[Sales Genius API] Invalid parameters property 'metafields.shop.sales_genius_rules'");
                this.evalExpectedParameter();
                return (_m = (_l = params.variant) === null || _l === void 0 ? void 0 : _l.price) !== null && _m !== void 0 ? _m : 0;
            }
            if (!((_p = (_o = params.metafields) === null || _o === void 0 ? void 0 : _o.variant) === null || _p === void 0 ? void 0 : _p.sales_genius_rules)) {
                console.warn("[Sales Genius API] Missing required parameters property 'metafields.shop.sales_genius_rules'");
                this.evalExpectedParameter();
                return (_r = (_q = params.variant) === null || _q === void 0 ? void 0 : _q.price) !== null && _r !== void 0 ? _r : 0;
            }
            else if (typeof params.metafields.variant.sales_genius_rules !== "string") {
                console.warn("[Sales Genius API] Invalid parameters property 'metafields.shop.sales_genius_rules'");
                this.evalExpectedParameter();
                return (_t = (_s = params.variant) === null || _s === void 0 ? void 0 : _s.price) !== null && _t !== void 0 ? _t : 0;
            }
            let results = {
                testOutput: { shop: { count: 0, trace: [] }, variant: { count: 0, trace: [] } },
                discountResult: { originalPrice: params.variant.price, id: -1, price: 0, priority: -1, type: "shop" }
            };
            const variantData = {
                price: params.variant.price,
                compare_at_price: (_u = params.variant.compareAtPrice) !== null && _u !== void 0 ? _u : params.variant.price,
                collections: (_v = params.variant.collectionsIds) !== null && _v !== void 0 ? _v : []
            };
            this.evaluateDiscounts(results, params.metafields.shop.sales_genius_rules, "shop", (_x = (_w = params.context) === null || _w === void 0 ? void 0 : _w.marketHandle) !== null && _x !== void 0 ? _x : null, (_z = (_y = params.context) === null || _y === void 0 ? void 0 : _y.segmentIds) !== null && _z !== void 0 ? _z : [], (_1 = (_0 = params.context) === null || _0 === void 0 ? void 0 : _0.isLoggedIn) !== null && _1 !== void 0 ? _1 : false, (_3 = (_2 = params.context) === null || _2 === void 0 ? void 0 : _2.date) !== null && _3 !== void 0 ? _3 : new Date(), variantData);
            this.evaluateDiscounts(results, params.metafields.variant.sales_genius_rules, "variant", (_5 = (_4 = params.context) === null || _4 === void 0 ? void 0 : _4.marketHandle) !== null && _5 !== void 0 ? _5 : null, (_7 = (_6 = params.context) === null || _6 === void 0 ? void 0 : _6.segmentIds) !== null && _7 !== void 0 ? _7 : [], (_9 = (_8 = params.context) === null || _8 === void 0 ? void 0 : _8.isLoggedIn) !== null && _9 !== void 0 ? _9 : false, (_11 = (_10 = params.context) === null || _10 === void 0 ? void 0 : _10.date) !== null && _11 !== void 0 ? _11 : new Date(), variantData);
            if (params.debug) {
                console.debug("[Sales Genius API] Evaluating discounts with params", params);
                for (const type of ["shop", "variant"]) {
                    const discounts = results.testOutput[type];
                    const nbDiscount = discounts.count;
                    console.debug(`\x1b[36m[Sales Genius API] Found ${nbDiscount} ${type} discounts\x1b[0m`);
                    if (nbDiscount > 0) {
                        const traceTable = [
                            ["Status"], ["Priority"], ["Type"], ["Value"], ["Collections"], ["Market"], ["Segment"],
                            ["Customer"], ["Start date"], ["End date"], ["Old price"], ["New price"], ["Comment"]
                        ];
                        let discountIndex = 0;
                        for (const discount of discounts.trace) {
                            const applied = discountIndex === results.discountResult.id && results.discountResult.type === type;
                            if (applied) {
                                traceTable[0].push(Object.assign(Object.assign({}, this.statusDetailsToString({ status: discount.modifiers.status })), { back: "green" }));
                                traceTable[1].push({ msg: discount.priority.toString(), back: "green" });
                                traceTable[2].push({ msg: this.typeToString(discount.modifiers.type), back: "green" });
                                traceTable[3].push({ msg: discount.modifiers.value.toString(), back: "green" });
                                traceTable[4].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.collections)), { back: "green" }));
                                traceTable[5].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.market)), { back: "green" }));
                                traceTable[6].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.segment)), { back: "green" }));
                                traceTable[7].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.customer)), { back: "green" }));
                                traceTable[8].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.start_date)), { back: "green" }));
                                traceTable[9].push(Object.assign(Object.assign({}, this.statusDetailsToString(discount.conditions.end_date)), { back: "green" }));
                                traceTable[10].push({
                                    msg: (discount.modifiers.status === "pass" ? results.discountResult.originalPrice.toString() : "-"),
                                    back: "green"
                                });
                                traceTable[11].push({
                                    msg: (discount.modifiers.status === "pass" ? discount.modifiers.description.newPrice.toString() : "-"),
                                    back: "green"
                                });
                                traceTable[12].push({ msg: "Applied", back: "green" });
                            }
                            else {
                                traceTable[0].push(this.statusDetailsToString({ status: discount.modifiers.status }));
                                traceTable[1].push(discount.priority.toString());
                                traceTable[2].push(this.typeToString(discount.modifiers.type));
                                traceTable[3].push(discount.modifiers.value.toString());
                                traceTable[4].push(this.statusDetailsToString(discount.conditions.collections));
                                traceTable[5].push(this.statusDetailsToString(discount.conditions.market));
                                traceTable[6].push(this.statusDetailsToString(discount.conditions.segment));
                                traceTable[7].push(this.statusDetailsToString(discount.conditions.customer));
                                traceTable[8].push(this.statusDetailsToString(discount.conditions.start_date));
                                traceTable[9].push(this.statusDetailsToString(discount.conditions.end_date));
                                traceTable[10].push(discount.modifiers.status === "pass" ? results.discountResult.originalPrice.toString() : "-");
                                traceTable[11].push(discount.modifiers.status === "pass" ? discount.modifiers.description.newPrice.toString() : "-");
                                traceTable[12].push(discount.modifiers.description.comment);
                            }
                            discountIndex++;
                        }
                        this.showTableWithColumns(traceTable);
                    }
                }
            }
            return results.discountResult.price > 0 ? results.discountResult.price : params.variant.price;
        },
        evaluateDiscounts: (results, discountsStr, discountsType, marketHandle, segmentIds, isLoggedIn, date, variantData) => {
            var _a;
            if (discountsType === "shop" && discountsStr.length === 0) {
                results.nothing = true;
                return;
            }
            if (discountsType === "variant" && discountsStr.length === 0) {
                results.nothing = results.nothing && true;
                return;
            }
            results.nothing = false;
            let testResults = {
                count: 0,
                trace: []
            };
            let nbDiscountsInGroup = 0;
            const groups = discountsStr.replace(/^"(.*)"$/, "$1").split("*");
            for (const ruleGroup of groups) {
                nbDiscountsInGroup += ruleGroup.split("|").length;
            }
            testResults.count = nbDiscountsInGroup;
            let discountResult;
            let skipGroup = false;
            let discountIndex = 0;
            let priority = 0;
            let alternativePriority = 0;
            for (const discountGroup of groups) {
                alternativePriority++;
                let discountsInGroup = "";
                skipGroup = false;
                const splittedWithPriority = discountGroup.split(":");
                if (splittedWithPriority.length === 2) {
                    priority = parseInt(splittedWithPriority[0]);
                    alternativePriority = priority + 1;
                    discountsInGroup = splittedWithPriority[1];
                }
                else {
                    priority = alternativePriority;
                    discountsInGroup = discountGroup;
                }
                if (results.discountResult.priority >= 0 && priority > results.discountResult.priority) {
                    skipGroup = true;
                }
                const discounts = discountsInGroup.split("|");
                for (const strDiscount of discounts) {
                    const discount = strDiscount.split(";");
                    function strDateToRealDate(strDate) {
                        if (strDate !== "") {
                            const year = "20" + strDate.substring(0, 2);
                            const month = strDate.substring(2, 4);
                            const day = strDate.substring(4, 6);
                            return year + "-" + month + "-" + day;
                        }
                        return "";
                    }
                    let i = 0;
                    if (discount.length == 9) {
                        i++;
                    }
                    const discountType = discount[i];
                    const discountTypeLabel = discount[i++];
                    const modifier = parseFloat(discount[i++]);
                    const discountStartDate = strDateToRealDate(discount[i++]);
                    const discountEndDate = strDateToRealDate(discount[i++]);
                    const discountSegments = discount[i++].split(",").filter((item) => item !== "");
                    const discountCustomers = discount[i++].split(",").filter((item) => item !== "");
                    const discountMarkets = discount[i++].split(",").filter((item) => item !== "");
                    let discountCollections = [];
                    if (discount[i] !== undefined) {
                        discountCollections = discount[i++].split(",").filter((item) => item !== "").map((item) => parseInt(item)).filter((item) => !isNaN(item));
                    }
                    discountResult = {
                        priority,
                        conditions: {
                            market: { details: discountMarkets.join(), status: "skipped" },
                            segment: { details: discountSegments.join(), status: "skipped" },
                            customer: { details: discountCustomers.join(), status: "skipped" },
                            start_date: { details: discountStartDate, status: "skipped" },
                            end_date: { details: discountEndDate, status: "skipped" },
                            collections: {
                                details: discountCollections.join(),
                                status: "skipped"
                            }
                        },
                        modifiers: {
                            type: discountTypeLabel,
                            value: modifier,
                            status: "skipped",
                            description: { comment: "", previousPrice: 0, newPrice: 0 }
                        }
                    };
                    if (skipGroup) {
                        discountResult.modifiers.description.comment = "Skipped group with lower priority";
                        testResults.trace.push(structuredClone(discountResult));
                        continue;
                    }
                    let collectionsIncluded = [];
                    for (const element of discountCollections) {
                        if (variantData.collections.includes(element)) {
                            collectionsIncluded.push(element);
                        }
                    }
                    if (discountsType === "variant" || discountCollections.length == 0 || collectionsIncluded.length >= 1) {
                        discountResult.conditions.collections.status = "pass";
                        if (!marketHandle || marketHandle == "" || discountMarkets.length == 0 || discountMarkets.includes(marketHandle)) {
                            discountResult.conditions.market.status = "pass";
                            if (discountSegments.length == 0 || discountSegments.includes(segmentIds.toString())) {
                                discountResult.conditions.segment.status = "pass";
                                if (discountCustomers.length == 0 || (discountCustomers.includes("-1") && isLoggedIn)) {
                                    discountResult.conditions.customer.status = "pass";
                                    if (discountStartDate == null || discountStartDate == "" || new Date(date) >= new Date(discountStartDate)) {
                                        discountResult.conditions.start_date.status = "pass";
                                        if (discountEndDate == null || discountEndDate == "" || new Date(date) <= new Date(discountEndDate)) {
                                            discountResult.conditions.end_date.status = "pass";
                                            let price = variantData.price;
                                            let compareAtPrice = (_a = variantData.compare_at_price) !== null && _a !== void 0 ? _a : price;
                                            let calculatedPrice = 0;
                                            if (discountType === SalesGenius_Amiparis.api.PRICE_MODIFIER_ABSOLUTE) {
                                                calculatedPrice = modifier;
                                            }
                                            else if (discountType === SalesGenius_Amiparis.api.PRICE_MODIFIER_PERCENTAGE_COMPAREATPRICE) {
                                                calculatedPrice = compareAtPrice * (100 - modifier) / 100;
                                            }
                                            else if (discountType === SalesGenius_Amiparis.api.PRICE_MODIFIER_PERCENTAGE_PRICE) {
                                                calculatedPrice = price * (100 - modifier) / 100;
                                            }
                                            else if (discountType === SalesGenius_Amiparis.api.PRICE_MODIFIER_AMOUNT_COMPAREATPRICE) {
                                                calculatedPrice = compareAtPrice - modifier;
                                            }
                                            else if (discountType === SalesGenius_Amiparis.api.PRICE_MODIFIER_AMOUNT_PRICE) {
                                                calculatedPrice = price - modifier;
                                            }
                                            else {
                                                calculatedPrice = NaN;
                                            }
                                            calculatedPrice = Math.round(calculatedPrice * 100) / 100;
                                            const previousPrice = (results.discountResult.price || results.discountResult.originalPrice);
                                            if (calculatedPrice > 0
                                                && (results.discountResult.price == 0
                                                    || calculatedPrice < results.discountResult.price
                                                    || results.discountResult.priority > priority
                                                    || (discountsType === "variant" && results.discountResult.priority == priority &&
                                                        (results.discountResult.type == "shop" || (results.discountResult.type == "variant" && calculatedPrice < results.discountResult.price)))) && price > calculatedPrice) {
                                                discountResult.modifiers.status = "pass";
                                                discountResult.modifiers.description.comment = "Discount may apply";
                                                discountResult.modifiers.description.previousPrice = previousPrice;
                                                discountResult.modifiers.description.newPrice = calculatedPrice;
                                                results.discountResult.price = calculatedPrice;
                                                results.discountResult.type = discountsType;
                                                results.discountResult.priority = priority;
                                                results.discountResult.id = discountIndex;
                                            }
                                            else {
                                                if (calculatedPrice <= 0) {
                                                    discountResult.modifiers.status = "fail";
                                                    discountResult.modifiers.description.comment = "Price invalid";
                                                    discountResult.modifiers.description.previousPrice = previousPrice;
                                                    discountResult.modifiers.description.newPrice = calculatedPrice;
                                                }
                                                else if (calculatedPrice >= results.discountResult.price) {
                                                    discountResult.modifiers.status = "skipped";
                                                    discountResult.modifiers.description.comment = "Price higher than the previous discount";
                                                    discountResult.modifiers.description.previousPrice = previousPrice;
                                                    discountResult.modifiers.description.newPrice = calculatedPrice;
                                                }
                                                else if (previousPrice <= calculatedPrice) {
                                                    discountResult.modifiers.status = "fail";
                                                    discountResult.modifiers.description.comment = "Price higher than product price";
                                                    discountResult.modifiers.description.previousPrice = previousPrice;
                                                    discountResult.modifiers.description.newPrice = calculatedPrice;
                                                }
                                                else {
                                                    discountResult.modifiers.status = "fail";
                                                    if (isNaN(calculatedPrice)) {
                                                        discountResult.modifiers.description.comment = "Invalid type";
                                                    }
                                                    else {
                                                        discountResult.modifiers.description.comment = "Unknown reason";
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            discountResult.modifiers.description.comment = "Conditions not met";
                                            discountResult.modifiers.status = "fail";
                                            discountResult.conditions.end_date.status = "fail";
                                        }
                                    }
                                    else {
                                        discountResult.modifiers.description.comment = "Conditions not met";
                                        discountResult.modifiers.status = "fail";
                                        discountResult.conditions.start_date.status = "fail";
                                    }
                                }
                                else {
                                    discountResult.modifiers.description.comment = "Conditions not met";
                                    discountResult.modifiers.status = "fail";
                                    discountResult.conditions.customer.status = "fail";
                                }
                            }
                            else {
                                discountResult.modifiers.description.comment = "Conditions not met";
                                discountResult.modifiers.status = "fail";
                                discountResult.conditions.segment.status = "fail";
                            }
                        }
                        else {
                            discountResult.modifiers.description.comment = "Conditions not met";
                            discountResult.modifiers.status = "fail";
                            discountResult.conditions.market.status = "fail";
                        }
                    }
                    else {
                        discountResult.modifiers.description.comment = "Conditions not met";
                        discountResult.conditions.collections.status = "fail";
                        discountResult.modifiers.status = "fail";
                    }
                    testResults.trace.push(structuredClone(discountResult));
                    discountIndex++;
                }
            }
            results.testOutput[discountsType] = testResults;
        }
    },
    eval: function (params) {
        var _a, _b;
        try {
            return SalesGenius_Amiparis.api.eval(params);
        }
        catch (error) {
            console.error("[Sales Genius API] Error evaluating discounts:", error);
            return (_b = (_a = params.variant) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0;
        }
    },
    displayDebugProduct: function (targetId) {
        if (targetId) {
            this.currentDebugTraceId = targetId;
        }
        else {
            targetId = this.currentDebugTraceId;
        }
        const mainElt = document.getElementById("sg-debug-product");
        const contentElt = document.getElementById("sg-debug-content-product");
        if (mainElt && contentElt) {
            const data = document.getElementById("sg-debug-data-product-" + targetId);
            const triggerElt = document.getElementById("sg-debug-trigger-product-" + targetId);
            if (data && triggerElt) {
                const visible = mainElt.style.display;
                if (visible === "none") {
                    contentElt.innerHTML = data.innerText;
                    mainElt.style.display = "block";
                    triggerElt.innerHTML = "Hide <b>Sales Genius rules</b> application details";
                }
                else {
                    mainElt.style.display = "none";
                    triggerElt.innerHTML = "Show <b>Sales Genius rules</b> application details";
                }
            }
        }
    },
    displayDebugAttributes: function () {
        const mainElt = document.getElementById("sg-debug-attributes");
        const contentElt = document.getElementById("sg-debug-content-attributes");
        if (mainElt && contentElt) {
            const triggerElt = document.getElementById("sg-debug-trigger-attributes");
            if (triggerElt) {
                const visible = mainElt.style.display;
                if (visible === "none") {
                    contentElt.innerHTML = this.cartUpdateDebugContent;
                    mainElt.style.display = "block";
                    triggerElt.innerHTML = "Hide <b>Sales Genius rules</b> cart attribute update details";
                }
                else {
                    mainElt.style.display = "none";
                    triggerElt.innerHTML = "Show <b>Sales Genius rules</b> cart attribute update details";
                }
            }
        }
    },
    getSections(sections, successCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            fetch(window.Shopify.routes.root + `?sections=` + sections.map((section) => section.id).join(","), {
                method: "GET",
                headers: { "content-type": "application/json" }
            })
                .then(res => res.json())
                .then(parsedState => successCallback(parsedState))
                .catch(err => document.location.reload());
        });
    },
    getSectionInnerHTML(html, selector = ".shopify-section") {
        const elt = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
        return elt ? elt.innerHTML : "";
    },
    reloadMiniCart: function () {
        return __awaiter(this, arguments, void 0, function* (reload = false) {
            const schemaTheme = window.Shopify.theme.schema_name;
            switch (schemaTheme) {
                case "Dawn":
                    const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
                    if (cartNotification) {
                        const sections = cartNotification.getSectionsToRender()
                            .filter((section) => section.id !== "cart-notification-product" && section.id !== "header");
                        yield SalesGenius_Amiparis.getSections(sections, (parsedState) => {
                            sections.forEach((section) => {
                                const sectionElt = section.selector
                                    ? document.querySelector(section.selector)
                                    : document.getElementById(section.id);
                                if (sectionElt) {
                                    sectionElt.innerHTML = SalesGenius_Amiparis.getSectionInnerHTML(parsedState[section.id], section.selector);
                                }
                            });
                        });
                        document.dispatchEvent(new CustomEvent("updateCart", {}));
                    }
                    else {
                        document.location.reload();
                    }
                    break;
                case "Prestige":
                    document.dispatchEvent(new CustomEvent("cart:refresh", {}));
                    break;
                case "Starter":
                    const sections = [{ id: "cart-drawer", section: "cart-drawer", selector: "#CartDrawer" }];
                    yield SalesGenius_Amiparis.getSections(sections, (parsedState) => {
                        sections.forEach((section) => {
                            const sectionElt = section.selector
                                ? document.querySelector(section.selector)
                                : document.getElementById(section.id);
                            if (sectionElt) {
                                sectionElt.innerHTML = SalesGenius_Amiparis.getSectionInnerHTML(parsedState[section.id], section.selector);
                            }
                        });
                    });
                    break;
                default:
                    if (reload) {
                        document.location.reload();
                    }
                    break;
            }
        });
    },
    checkCart() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const itemIds = yield SalesGenius_Amiparis.cart.getItemIds();
            const allRules = yield SalesGenius_Amiparis.cart.getAllRulesFromCartAttributes(true);
            const previousShopRules = (_a = SalesGenius_Amiparis.cart.cartCache.attributes.sg_discounts) !== null && _a !== void 0 ? _a : "";
            let requireMiniCartReload = false;
            for (const variantId of itemIds) {
                const discounts = document.getElementById("sg_rules_" + variantId);
                if (discounts) {
                    allRules[variantId] = discounts.innerText;
                    requireMiniCartReload = true;
                }
                else if (allRules[variantId] === undefined) {
                    allRules[variantId] = "";
                    requireMiniCartReload = true;
                }
            }
            if (this.rules.discounts_catalog !== previousShopRules || requireMiniCartReload) {
                SalesGenius_Amiparis.collectRules(null, allRules);
                yield SalesGenius_Amiparis.cart.updateRulesAttributes();
                SalesGenius_Amiparis.reloadMiniCart();
            }
        });
    },
    initVariantChangeObserver: function () {
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    for (const node of mutation.addedNodes) {
                        if (node.id === "sg_rules") {
                            this.collectRules(node);
                        }
                    }
                }
            }
        };
        const config = { attributes: false, childList: true, subtree: true };
        const observer = new MutationObserver(callback);
        observer.observe(document, config);
    },
    checkFreeGift: function () {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.debug("############### Checking Free Gift ###############");
            const storedDiscountsFreeGift = SalesGenius_Amiparis.rules.discounts_free_gift;
            const discountsFreeGift = storedDiscountsFreeGift.split("*").filter((rule) => rule !== "");
            this.debug("Discounts Free Gift", storedDiscountsFreeGift);
            const discountApplied = [];
            let oldAppliedFreeGifts = "";
            let reloadRequired = false;
            if (!discountsFreeGift.length) {
                this.debug("No discount found");
            }
            else {
                SalesGenius_Amiparis.cart.itemIds = yield SalesGenius_Amiparis.cart.getItemIds();
                oldAppliedFreeGifts = (_a = SalesGenius_Amiparis.cart.cartCache.attributes.sg_discounts_free_gifts) !== null && _a !== void 0 ? _a : "";
                const currencyRate = window.Shopify.currency.rate;
                const amount = SalesGenius_Amiparis.cart.cartCache.total_price * currencyRate / 100;
                this.debug("Discounted amount", amount);
                for (const freeGiftRule of discountsFreeGift) {
                    const idAndRule = freeGiftRule.split(":");
                    const id = idAndRule[0];
                    this.debug("Rule", id);
                    const splittedRule = idAndRule[1].split(";");
                    const freeGiftData = splittedRule[7].split(",");
                    const productId = freeGiftData[0];
                    const quantity = parseInt(freeGiftData[1]);
                    const minAmount = freeGiftData[2] !== "" ? parseInt(freeGiftData[2]) : 0;
                    const maxAmount = freeGiftData[3] !== "" ? parseInt(freeGiftData[3]) : Infinity;
                    this.debug("Product", productId, "|", "Amount", minAmount, "-", maxAmount, "|", "Quantity", quantity);
                    const cartItemForProductId = SalesGenius_Amiparis.cart.cartCache.items.find((item) => item.id.toString() === productId);
                    const cartItemQuantity = cartItemForProductId ? cartItemForProductId.quantity : 0;
                    const cartItemFinalPrice = cartItemForProductId ? (cartItemForProductId.final_price * currencyRate / 100) * cartItemQuantity : 0;
                    this.debug("Cart item", cartItemForProductId === null || cartItemForProductId === void 0 ? void 0 : cartItemForProductId.id, "|", "Quantity", cartItemQuantity, "|", "Final price", cartItemFinalPrice);
                    const finalAmountToCheck = amount - cartItemFinalPrice;
                    this.debug("Final amount to check", finalAmountToCheck);
                    if (minAmount < finalAmountToCheck && finalAmountToCheck < maxAmount) {
                        discountApplied.push(id + ":" + splittedRule.slice(0, 7).join(";") + ";" + productId + "," + quantity);
                        this.debug("** Discount applied ** ");
                        if (cartItemQuantity < quantity) {
                            SalesGenius_Amiparis.cart.itemIds.push(productId);
                            yield SalesGenius_Amiparis.cart.updateRulesAttributes();
                            this.debug(`Adding ${quantity - cartItemQuantity} product ${productId} to the cart`);
                            SalesGenius_Amiparis.cart.itemIds = [...new Set([...SalesGenius_Amiparis.cart.itemIds, productId])];
                            SalesGenius_Amiparis.rules.discounts_cart_items[productId] = "";
                            yield fetch(window.Shopify.routes.root + "cart/add.js", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    "items": [{
                                            "id": productId,
                                            "quantity": quantity - cartItemQuantity
                                        }]
                                })
                            }).then(response => {
                                reloadRequired || (reloadRequired = true);
                            });
                        }
                        else {
                            this.debug(`Product ${productId} already in the cart with the right quantity`);
                        }
                    }
                    else {
                        this.debug("/!\ Discount not applied /!\\");
                    }
                }
            }
            const newDiscountsFreeGift = discountApplied.join("*");
            if (oldAppliedFreeGifts !== newDiscountsFreeGift) {
                reloadRequired || (reloadRequired = true);
            }
            yield fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: { sg_discounts_free_gifts: newDiscountsFreeGift } })
            })
                .then(response => response.json())
                .catch((error) => console.error("Error:", error))
                .finally(() => {
                if (reloadRequired) {
                    const pathName = document.location.pathname;
                    if (pathName === "/cart") {
                        document.location.reload();
                        return;
                    }
                    SalesGenius_Amiparis.reloadMiniCart(true);
                }
            });
        });
    },
    initCartUpdateObservers: function () {
        const addToCartUrl = `cart/add`;
        const changeCartUrl = `cart/change`;
        const updateCartUrl = `cart/update`;
        XMLHttpRequest = new Proxy(XMLHttpRequest, {
            construct: function (target, args) {
                const xhr = new target(...args);
                xhr.onreadystatechange = function () {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (xhr.readyState === 1) {
                        }
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                const url = xhr._url;
                                if (url && url.toString().endsWith("/" + addToCartUrl + ".js")
                                    || url.toString().endsWith("/" + changeCartUrl + ".js")) {
                                    SalesGenius_Amiparis.cart.itemIds = yield SalesGenius_Amiparis.cart.getItemIds();
                                    yield SalesGenius_Amiparis.cart.updateRulesAttributes();
                                    yield SalesGenius_Amiparis.checkFreeGift();
                                }
                            }
                        }
                    });
                };
                return xhr;
            }
        });
        let addToCartInProgress = false;
        window.fetch = new Proxy(window.fetch, {
            apply: function (target, that, args) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (args[0].toString().endsWith(changeCartUrl)
                        || args[0].toString().endsWith(updateCartUrl)
                        || args[0].toString().endsWith("/" + changeCartUrl)
                        || args[0].toString().endsWith("/" + updateCartUrl)) {
                        let temp = target.apply(that, args);
                        temp.finally(() => __awaiter(this, void 0, void 0, function* () {
                            SalesGenius_Amiparis.cart.itemIds = yield SalesGenius_Amiparis.cart.getItemIds();
                            yield SalesGenius_Amiparis.checkFreeGift();
                        }));
                        return temp;
                    }
                    else if (args[0].toString().endsWith(addToCartUrl)
                        || args[0].toString().endsWith("/" + addToCartUrl)
                        || args[0].toString().endsWith(addToCartUrl + ".js")
                        || args[0].toString().endsWith("/" + addToCartUrl + ".js")) {
                        if (addToCartInProgress) {
                            return;
                        }
                        addToCartInProgress = true;
                        SalesGenius_Amiparis.cart.itemIds = yield SalesGenius_Amiparis.cart.getItemIds();
                        if (args[1]) {
                            let variantIds = [];
                            if (args[1].body instanceof FormData) {
                                const body = args[1].body;
                                const id = body.get("id");
                                if (id) {
                                    variantIds.push(id.toString());
                                }
                            }
                            else if (args[1].body instanceof String) {
                                const body = args[1].body;
                                const id = JSON.parse(body).id;
                                if (id) {
                                    variantIds.push(id);
                                }
                                else {
                                    const items = JSON.parse(body).items;
                                    if (items) {
                                        for (const item of items) {
                                            variantIds.push(item.id);
                                        }
                                    }
                                }
                            }
                            else if (typeof args[1].body === "string") {
                                const params = new URLSearchParams(args[1].body);
                                const body = Object.fromEntries(params.entries());
                                if (body.id) {
                                    variantIds.push(body.id);
                                }
                            }
                            if (variantIds.length) {
                                for (const variantId of variantIds) {
                                    SalesGenius_Amiparis.cart.itemIds = [...new Set([...SalesGenius_Amiparis.cart.itemIds, variantId])];
                                    const discounts = document.getElementById("sg_rules_" + variantId);
                                    if (discounts) {
                                        SalesGenius_Amiparis.rules.discounts_target = variantId + "@" + discounts.innerText;
                                    }
                                    else {
                                        SalesGenius_Amiparis.rules.discounts_target = variantId + "@";
                                    }
                                }
                            }
                        }
                        yield SalesGenius_Amiparis.cart.updateRulesAttributes();
                        let temp = yield target.apply(that, args);
                        addToCartInProgress = false;
                        yield SalesGenius_Amiparis.checkFreeGift();
                        return temp;
                    }
                    else {
                        return target.apply(that, args);
                    }
                });
            }
        });
    },
    initFocusObservers: function () {
        let hasFocus = true;
        setInterval(function () {
            let newHasFocus = !document.hidden;
            if (!hasFocus && newHasFocus) {
                SalesGenius_Amiparis.checkCart();
            }
            hasFocus = newHasFocus;
        }, 500);
    },
    collectRules: function (jsonRulesElement, discountsCartItems, shopRules) {
        var _a, _b;
        if (!jsonRulesElement) {
            jsonRulesElement = document.getElementById("sg_rules");
        }
        if (jsonRulesElement) {
            const rules = (_b = JSON.parse((_a = jsonRulesElement.textContent) !== null && _a !== void 0 ? _a : "{}")) !== null && _b !== void 0 ? _b : {};
            this.rules = rules;
            this.rules.raw_discounts_catalog = this.rules.discounts_catalog;
        }
        if (discountsCartItems) {
            this.rules.discounts_cart_items = discountsCartItems;
        }
        if (shopRules) {
            this.rules.raw_discounts_catalog = shopRules;
        }
        if (SalesGenius_Amiparis.debugFlag) {
            this.cartUpdateDebugContent += `
                ${new Date().toLocaleTimeString()} - Collected rules: <br/>
                <ul><li> discounts_cart_items:<ul>${""}</ul></li>
                <li> discounts_target: ${this.rules.discounts_target}</li>
                <li> original discounts_catalog: ${this.rules.discounts_catalog}</li>`;
        }
        this.sanitizeShopRules();
        if (SalesGenius_Amiparis.debugFlag) {
            this.cartUpdateDebugContent += `<li> sanitized discounts_catalog: ${this.rules.discounts_catalog}</li></ul>`;
        }
    },
    sanitizeShopRules: function () {
        var _a, _b;
        const shopRulesToApply = [];
        if (this.rules.raw_discounts_catalog === "") {
            return;
        }
        const shopRulesByPriority = (this.rules.raw_discounts_catalog).split("*");
        let priority = 0;
        for (const rulesByPriority of shopRulesByPriority) {
            const rules = rulesByPriority.split("|");
            const finalRules = rules.map(rule => rule.split(";"));
            for (const rule of finalRules) {
                const collections = rule[7];
                if (collections === "") {
                    if (!shopRulesToApply[priority]) {
                        shopRulesToApply[priority] = [];
                    }
                    shopRulesToApply[priority].push(rule.join(";"));
                }
                else {
                    const collectionsArray = collections.split(",");
                    const productsArray = [];
                    for (const productId of SalesGenius_Amiparis.cart.itemIds) {
                        const jsonRulesElement = document.getElementById("sg_variant_collections_" + productId);
                        if (jsonRulesElement) {
                            const collections = (_b = JSON.parse((_a = jsonRulesElement.textContent) !== null && _a !== void 0 ? _a : "[]")) !== null && _b !== void 0 ? _b : [];
                            this.cart.itemsCollections[productId] = collections;
                        }
                        else {
                            if (!this.cart.itemsCollections.hasOwnProperty(productId)) {
                                this.cart.itemsCollections[productId] = [];
                            }
                        }
                        const filteredArray = this.cart.itemsCollections[productId].filter(value => collectionsArray.includes(value.toString()));
                        if (filteredArray.length) {
                            if (!shopRulesToApply[priority]) {
                                shopRulesToApply[priority] = [];
                            }
                            productsArray.push(productId);
                        }
                    }
                    if (productsArray.length) {
                        rule[7] = productsArray.join(",");
                        shopRulesToApply[priority].push(rule.join(";"));
                    }
                }
            }
            priority++;
        }
        const rulesWithProducts = [];
        for (const rulesByPriority of shopRulesToApply) {
            rulesWithProducts.push(rulesByPriority.join("|"));
        }
        this.rules.discounts_catalog = rulesWithProducts.join("*");
    },
    checkForReload() {
        this.initFocusObservers();
    },
    cart: {
        lastUpdate: 0,
        itemIds: [],
        itemsCollections: {},
        cartCache: {},
        updateRulesAttributes() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                const currentUpdate = new Date().getTime();
                let rules = [];
                const allRules = yield SalesGenius_Amiparis.cart.getAllRulesFromCartAttributes();
                SalesGenius_Amiparis.rules.discounts_cart_items = Object.assign(Object.assign({}, SalesGenius_Amiparis.rules.discounts_cart_items), allRules);
                if (SalesGenius_Amiparis.rules.discounts_cart_items) {
                    for (const cartItemId in SalesGenius_Amiparis.rules.discounts_cart_items) {
                        const rule = cartItemId + "@" + ((_a = SalesGenius_Amiparis.rules.discounts_cart_items[cartItemId]) !== null && _a !== void 0 ? _a : "");
                        if (rule) {
                            rules.push(rule);
                        }
                    }
                }
                const selectedVariantElt = document.getElementById("ProductSelect-product-template");
                if (selectedVariantElt) {
                    const selectedVariantId = selectedVariantElt.value;
                    SalesGenius_Amiparis.rules.discounts_target = selectedVariantId + "@" + SalesGenius_Amiparis.rules.discounts_variants[selectedVariantId];
                }
                if (SalesGenius_Amiparis.rules.discounts_target !== "" && !rules.some((rule) => rule === SalesGenius_Amiparis.rules.discounts_target)) {
                    rules = [SalesGenius_Amiparis.rules.discounts_target, ...rules];
                    const variantRules = SalesGenius_Amiparis.rules.discounts_target.split("@");
                    const variantId = variantRules[0];
                    SalesGenius_Amiparis.rules.discounts_cart_items[variantId] = variantRules[1];
                }
                SalesGenius_Amiparis.sanitizeShopRules();
                const attributes = {
                    sg_discounts_catalog: SalesGenius_Amiparis.rules.discounts_catalog,
                    sg_discounts_product_0: "",
                    sg_discounts_product_1: "",
                    sg_discounts_product_2: "",
                    sg_discounts_product_3: "",
                    sg_discounts_product_4: "",
                    sg_discounts_product_5: "",
                    sg_discounts_product_6: "",
                    sg_discounts_product_7: "",
                    sg_discounts_product_8: "",
                    sg_discounts_product_9: "",
                    last_update: currentUpdate
                };
                let counter = 0;
                for (const rule of rules) {
                    let index = counter % (SalesGenius_Amiparis.nbDiscounts * 2);
                    const nextTmpRules = attributes["sg_discounts_product_" + index] + "_" + rule;
                    attributes["sg_discounts_product_" + index] = nextTmpRules;
                    counter++;
                }
                for (let index = 0; index < (SalesGenius_Amiparis.nbDiscounts * 2); index++) {
                    if (attributes.hasOwnProperty("sg_discounts_product_" + index)) {
                        attributes["sg_discounts_product_" + index] = attributes["sg_discounts_product_" + index].slice(1);
                    }
                }
                yield fetch(window.Shopify.routes.root + "cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ attributes })
                })
                    .then(response => response.json())
                    .catch((error) => console.error("Error:", error))
                    .finally(() => {
                    if (SalesGenius_Amiparis.debugFlag) {
                        SalesGenius_Amiparis.cartUpdateDebugContent += `
                        ${new Date().toLocaleTimeString()} - Cart attributes updated with rules: <br/>
                            <ul>
                            <li> sg_discounts: ${attributes.sg_discounts}</li>
                            <li> sg_discounts_product_0: ${attributes.sg_discounts_product_0}</li>
                            <li> sg_discounts_product_1: ${attributes.sg_discounts_product_1}</li>
                            <li> sg_discounts_product_2: ${attributes.sg_discounts_product_2}</li>
                            <li> sg_discounts_product_3: ${attributes.sg_discounts_product_3}</li>
                            <li> sg_discounts_product_4: ${attributes.sg_discounts_product_4}</li>
                            <li> sg_discounts_product_5: ${attributes.sg_discounts_product_5}</li>
                            <li> sg_discounts_product_6: ${attributes.sg_discounts_product_6}</li>
                            <li> sg_discounts_product_7: ${attributes.sg_discounts_product_7}</li>
                            <li> sg_discounts_product_8: ${attributes.sg_discounts_product_8}</li>
                            <li> sg_discounts_product_9: ${attributes.sg_discounts_product_9}</li>
                            </ul>
                        `;
                    }
                    if (this.lastUpdate > 0 && currentUpdate - this.lastUpdate > 3 * 60 * 60 * 1000) {
                        document.location.reload();
                    }
                });
            });
        },
        getItemIds() {
            return __awaiter(this, void 0, void 0, function* () {
                return yield fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET"
                })
                    .then(response => response.json())
                    .then((cart) => {
                    this.cartCache = cart;
                    return [...new Set(cart.items.map((item) => item.id.toString()))];
                })
                    .catch((error) => {
                    console.error("Error:", error);
                    return [];
                });
            });
        },
        getAmount() {
            return __awaiter(this, void 0, void 0, function* () {
                return yield fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET"
                })
                    .then(response => response.json())
                    .then((cart) => {
                    this.cartCache = cart;
                    const currencyRate = window.Shopify.currency.rate;
                    return cart.total_price * currencyRate / 100;
                })
                    .catch((error) => {
                    console.error("Error:", error);
                    return [];
                });
            });
        },
        getAllRulesFromCartAttributes() {
            return __awaiter(this, arguments, void 0, function* (fromCache = false) {
                function internalExtractData(cart) {
                    var _a;
                    const cartItemIds = [...new Set(cart.items.map((item) => item.id.toString()))];
                    const allRules = {};
                    const attributes = (_a = cart.attributes) !== null && _a !== void 0 ? _a : {};
                    for (let i = 0; i < (SalesGenius_Amiparis.nbDiscounts * 2); i++) {
                        if (attributes["sg_discounts_product_" + i]) {
                            const rulesByProduct = attributes["sg_discounts_product_" + i].split("_");
                            for (const rules of rulesByProduct) {
                                const id = rules.split("@")[0];
                                const data = rules.split("@")[1];
                                if (cartItemIds.find((itemId) => itemId === id)
                                    && (!allRules.hasOwnProperty(id) || allRules[id] === "")) {
                                    allRules[id] = data;
                                }
                            }
                        }
                    }
                    return allRules;
                }
                if (fromCache) {
                    return internalExtractData(this.cartCache);
                }
                else {
                    return yield fetch(window.Shopify.routes.root + "cart.js", {
                        method: "GET"
                    })
                        .then(response => response.json())
                        .then((cart) => {
                        this.cartCache = cart;
                        return internalExtractData(this.cartCache);
                    })
                        .catch((error) => {
                        console.error("Error:", error);
                        return "";
                    });
                }
            });
        },
        cartItems: [],
        getItems() {
            return __awaiter(this, void 0, void 0, function* () {
                yield fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET"
                })
                    .then(response => response.json())
                    .then((cart) => {
                    this.cartCache = cart;
                    this.cartItems = cart.items.map((item) => item.id.toString());
                    return cart.items.map((item) => item.id.toString());
                })
                    .catch((error) => console.error("Error:", error));
            });
        },
        updateAttributes(rules) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.updateRulesAttributes();
            });
        },
        checkAndReload(previousRules) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.updateRulesAttributes();
            });
        },
        add(variantId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!SalesGenius_Amiparis.jsApiEnabled)
                    return;
                const cartItems = yield this.getItemIds();
                if (variantId && !cartItems.includes(variantId.toString())) {
                    cartItems.push(variantId.toString());
                }
                this.updateRules(cartItems);
            });
        },
        remove(lineId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!SalesGenius_Amiparis.jsApiEnabled)
                    return;
                const cartItems = yield this.getItemIds();
                const lineIdToRemove = parseInt(lineId.toString());
                const newCartItems = cartItems.filter((item, index) => {
                    return index + 1 !== lineIdToRemove;
                });
                this.updateRules(newCartItems);
            });
        },
        updateRules(cartItemsIds) {
            if (!SalesGenius_Amiparis.jsApiEnabled)
                return;
            this.getRules(cartItemsIds)
                .then((rules) => {
                if (rules) {
                    SalesGenius_Amiparis.rules.discounts_cart_items = rules.discounts_cart_items;
                    SalesGenius_Amiparis.rules.discounts_catalog = rules.discounts_catalog;
                    this.updateRulesAttributes();
                }
            })
                .catch((err) => {
                console.error(err);
            });
        },
        getRules(cartItemsIds) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!SalesGenius_Amiparis.jsApiEnabled)
                    return;
                const app_proxy_subpath = "sales-genius";
                let cartItems = [];
                if (!cartItemsIds) {
                    cartItems = yield this.getItemIds();
                }
                else {
                    cartItems = cartItemsIds;
                }
                const fetchOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ids: cartItems })
                };
                return new Promise((resolve, reject) => {
                    fetch("/apps/" + app_proxy_subpath + "/get-rules", fetchOptions)
                        .then((response) => __awaiter(this, void 0, void 0, function* () {
                        if (response.status == 200) {
                            const rules = yield response.json();
                            const p = rules.p;
                            const products = p.split("_");
                            const productRules = {};
                            for (const product of products) {
                                const [id, rule] = product.split("@");
                                productRules[id] = rule;
                            }
                            resolve({ discounts_cart_items: productRules, discounts_catalog: rules.s });
                        }
                        else {
                            resolve(null);
                        }
                    }))
                        .catch((err) => {
                        reject(err);
                    });
                });
            });
        },
        displaySgDebugAttributes() {
            return;
        }
    },
    debug: function (...args) {
        if (SalesGenius_Amiparis.debugFlag) {
            console.debug.apply(this, args);
        }
    }
};
